import React, {
  useState,
  useEffect,
  useReducer,
  useCallback,
  useContext,
} from "react";
import { toast } from "react-toastify";
import { useHistory } from "react-router-dom"; // Importe o useHistory

import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Button from "@material-ui/core/Button";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import IconButton from "@material-ui/core/IconButton";
import SearchIcon from "@material-ui/icons/Search";
import TextField from "@material-ui/core/TextField";
import InputAdornment from "@material-ui/core/InputAdornment";
import { FormControl, InputLabel, Select, MenuItem, Typography } from "@material-ui/core";
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";
import EditIcon from "@material-ui/icons/Edit";

import MainContainer from "../../components/MainContainer";
import MainHeader from "../../components/MainHeader";
import MainHeaderButtonsWrapper from "../../components/MainHeaderButtonsWrapper";
import Title from "../../components/Title";
import TableRowSkeleton from "../../components/TableRowSkeleton";

import BrandModal from "../../components/BrandModal";
import KanbanBoardModal from "../../components/KanbanBoardModal";

import TagModal from "../../components/TagModal";
import ConfirmationModal from "../../components/ConfirmationModal";
import toastError from "../../errors/toastError";
import { Chip } from "@material-ui/core";
// import { SocketContext } from "../../context/Socket/SocketContext";
import { AuthContext } from "../../context/Auth/AuthContext";

import api from "../../services/api";
import { i18n } from "../../translate/i18n";
import { getKanbanLaneOrder } from "../../services/companyKanbanService";

import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import Collapse from '@material-ui/core/Collapse';
import Box from '@material-ui/core/Box';
import EditLaneTagModal from "../../components/EditLaneTagModal";

const reducer = (state, action) => {
  if (action.type === "LOAD_TAGS") {
    const tags = action.payload;
    const newTags = [];

    tags.forEach((tag) => {
      const tagIndex = state.findIndex((s) => s.id === tag.id);
      if (tagIndex !== -1) {
        state[tagIndex] = tag;
      } else {
        newTags.push(tag);
      }
    });

    return [...state, ...newTags];
  }

  if (action.type === "UPDATE_TAGS") {
    const tag = action.payload;
    const tagIndex = state.findIndex((s) => s.id === tag.id);

    if (tagIndex !== -1) {
      state[tagIndex] = tag;
      return [...state];
    } else {
      return [tag, ...state];
    }
  }

  if (action.type === "DELETE_TAGS") {
    const tagId = action.payload;

    const tagIndex = state.findIndex((s) => s.id === tagId);
    if (tagIndex !== -1) {
      state.splice(tagIndex, 1);
    }
    return [...state];
  }

  if (action.type === "RESET") {
    return [];
  }
};

const useStyles = makeStyles((theme) => ({
  mainPaper: {
    flex: 1,
    padding: theme.spacing(0, 1, 1, 1), // Remove top padding so sticky header touches top
    overflowY: "auto",
    maxHeight: "calc(100vh - 120px)", // Ensure container has a height limit for sticky to work against
    ...theme.scrollbarStyles,
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightBold,
  },
  accordionDetails: {
    padding: 0,
  },
  stickyTableHeader: {
    backgroundColor: theme.palette.background.paper,
    zIndex: 10,
    top: '48px !important',
  },
  stickySummary: {
    position: "sticky !important",
    top: '0px !important',
    zIndex: 11,
    backgroundColor: theme.palette.background.paper,
  },
  accordion: {
    margin: "0px !important",
    '&:before': {
      display: 'none', // Remove default divider line that might cause gaps
    },
  },
}));

const Row = (props) => {
  const { tag, handleEditTag, setConfirmModalOpen, setDeletingTag, handleEditLaneTag, handleDeleteLaneTag, classes } = props;
  const [open, setOpen] = useState(false);

  // Parse laneTags: Prioritize Relational (kanbanLaneTags)
  let laneTags = [];
  if (tag.kanbanLaneTags && tag.kanbanLaneTags.length > 0) {
    // [ANTIGRAVITY] Sort by KLT ID (Insertion Order) instead of Tag ID
    const sortedKLT = [...tag.kanbanLaneTags].sort((a, b) => a.id - b.id);
    laneTags = sortedKLT.map(klt => klt.tag).filter(t => !!t);
  } else {
    laneTags = [];
  }

  const { isFirst, isLast, onMoveUp, onMoveDown } = props;

  return (
    <React.Fragment>
      <TableRow className={classes.root}>
        <TableCell width="5%">
          <IconButton aria-label="expand row" size="small" onClick={() => setOpen(!open)}>
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        <TableCell align="center" style={{ width: '15%' }}>
          <IconButton
            size="small"
            disabled={isFirst}
            onClick={onMoveUp}
            title="Subir Etapa"
          >
            <KeyboardArrowUpIcon />
          </IconButton>
          <IconButton
            size="small"
            disabled={isLast}
            onClick={onMoveDown}
            title="Bajar Etapa"
          >
            <KeyboardArrowDownIcon />
          </IconButton>
        </TableCell>
        <TableCell align="center" onClick={() => setOpen(!open)} style={{ cursor: "pointer" }}>
          <Chip
            variant="outlined"
            style={{
              backgroundColor: tag.color,
              textShadow: "1px 1px 1px #000",
              color: "white",
            }}
            label={tag.name}
            size="small"
          />
        </TableCell>
        <TableCell align="center" onClick={() => setOpen(!open)} style={{ cursor: "pointer" }}>
          {tag?.ticketTags ? (
            <span>{tag?.ticketTags?.length}</span>
          ) : (
            <span>0</span>
          )}
        </TableCell>
        <TableCell align="center">
          <IconButton size="small" onClick={() => handleEditTag(tag)}>
            <EditIcon />
          </IconButton>
          <IconButton
            size="small"
            onClick={(e) => {
              setConfirmModalOpen(true);
              setDeletingTag(tag);
            }}
          >
            <DeleteOutlineIcon />
          </IconButton>
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box margin={1}>
              <Typography variant="h6" gutterBottom component="div" style={{ fontSize: '14px' }}>
                {i18n.t("tagModal.form.laneTags")} - {tag.name}
              </Typography>
              <Table size="small" aria-label="purchases">
                <TableHead>
                  <TableRow>
                    <TableCell>{i18n.t("tagsKanban.table.name")}</TableCell>
                    <TableCell align="right">{i18n.t("tagsKanban.table.actions")}</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {laneTags.length > 0 ? (
                    laneTags.map((laneTag, index) => (
                      <TableRow key={index}>
                        <TableCell component="th" scope="row">
                          <Chip
                            variant="outlined"
                            style={{
                              backgroundColor: tag.color,
                              textShadow: "1px 1px 1px #000",
                              color: "white",
                            }}
                            label={laneTag.name}
                            size="small"
                          />
                        </TableCell>
                        <TableCell align="right">
                          <IconButton size="small" onClick={() => handleEditLaneTag(tag, laneTag)}>
                            <EditIcon />
                          </IconButton>
                          <IconButton size="small" onClick={() => handleDeleteLaneTag(tag, laneTag)}>
                            <DeleteOutlineIcon />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell colSpan={2}>
                        <Typography variant="body2" color="textSecondary">
                          {i18n.t("tagsKanban.table.noTags")}
                        </Typography>
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
};

const Tags = () => {
  const classes = useStyles();
  const history = useHistory();
  const { user, socket } = useContext(AuthContext);

  const [loading, setLoading] = useState(false);
  const [selectedTag, setSelectedTag] = useState(null);
  const [deletingTag, setDeletingTag] = useState(null);
  const [confirmModalOpen, setConfirmModalOpen] = useState(false);
  const [searchParam, setSearchParam] = useState("");
  const [tags, dispatch] = useReducer(reducer, []);
  const [tagModalOpen, setTagModalOpen] = useState(false);
  
  const [brands, setBrands] = useState([]);
  const [activeBrandId, setActiveBrandId] = useState("");
  const [brandModalOpen, setBrandModalOpen] = useState(false);
  const [selectedBrandId, setSelectedBrandId] = useState(null);
  
  const [boardModalOpen, setBoardModalOpen] = useState(false);
  const [selectedBoardId, setSelectedBoardId] = useState(null);

  const fetchBrands = async () => {
    try {
      const { data } = await api.get("/brands");
      setBrands(data);
      if (data.length > 0 && !activeBrandId) {
        setActiveBrandId(data[0].id);
      }
    } catch (err) {
      toastError(err);
    }
  };

  useEffect(() => {
    fetchBrands();
  }, [activeBrandId]);

  const [boards, setBoards] = useState([]);
  const [laneOrders, setLaneOrders] = useState({});

  // States for EditLaneTagModal
  const [editLaneTagModalOpen, setEditLaneTagModalOpen] = useState(false);
  const [selectedLaneTag, setSelectedLaneTag] = useState({ tag: null, value: "" });

  useEffect(() => {
    const fetchBoards = async () => {
      try {
        if (!activeBrandId) return;
        const { data } = await api.get(`/kanban-boards?brandId=${activeBrandId}`);
        setBoards(data);
      } catch (err) {
        toastError(err);
      }
    };
    fetchBoards();
  }, []);

  useEffect(() => {
    const fetchOrders = async () => {
      const orders = {};
      for (const board of boards) {
        try {
          const order = await getKanbanLaneOrder(board.id);
          orders[board.id] = order;
        } catch (err) {
          console.error(`Error fetching order for board ${board.id}`, err);
        }
      }
      setLaneOrders(orders);
    };

    if (boards.length > 0) {
      fetchOrders();
    }
  }, [boards]);

  useEffect(() => {
    setLoading(true);
    const delayDebounceFn = setTimeout(() => {
      const fetchTags = async () => {
        try {
          const { data } = await api.get("/tags/", {
            params: { searchParam, kanban: 1, limit: "-1" },
          });
          dispatch({ type: "LOAD_TAGS", payload: data.tags });
          setLoading(false);
        } catch (err) {
          toastError(err);
        }
      };
      fetchTags();
    }, 500);
    return () => clearTimeout(delayDebounceFn);
  }, [searchParam]);

  useEffect(() => {
    dispatch({ type: "RESET" });
  }, [searchParam]);

  useEffect(() => {
    const onTagsEvent = (data) => {
      if (data.action === "update" || data.action === "create") {
        // [ANTIGRAVITY] Fix: Only update if it is a Kanban Stage (1)
        if (data.tag.kanban === 1) {
          dispatch({ type: "UPDATE_TAGS", payload: data.tag });
        }
      }
      if (data.action === "delete") {
        dispatch({ type: "DELETE_TAGS", payload: +data.tagId });
      }
    };
    socket.on(`company${user.companyId}-tag`, onTagsEvent);
    return () => {
      socket.off(`company${user.companyId}-tag`, onTagsEvent);
    };
  }, [socket, user.companyId]);

  const handleOpenTagModal = () => {
    setSelectedTag(null);
    setTagModalOpen(true);
  };

  const handleCloseTagModal = () => {
    setSelectedTag(null);
    setTagModalOpen(false);
  };

  const handleSearch = (event) => {
    setSearchParam(event.target.value.toLowerCase());
  };

  const handleEditTag = (tag) => {
    setSelectedTag(tag);
    setTagModalOpen(true);
  };

  const handleDeleteTag = async (tagId) => {
    try {
      await api.delete(`/tags/${tagId}`);
      toast.success(i18n.t("tags.toasts.deleted"));
    } catch (err) {
      toastError(err);
    }
    setDeletingTag(null);
    setSearchParam("");
  };

  const handleReturnToKanban = () => {
    history.push("/kanban");
  };

  // Lane Tags Handlers
  const handleDeleteLaneTag = async (lane, tagObj) => {
    try {
      const tagId = tagObj.id;
      const tagName = tagObj.name || tagObj; // Fallback if string

      // 1. Validation for ID-based tags
      if (tagId) {
        try {
          // Check if tag is in use (ticketTags)
          // We can check this by fetching the specific tag by ID
          const { data } = await api.get(`/tags/${tagId}`);
          if (data && data.ticketTags && data.ticketTags.length > 0) {
            toast.error(i18n.t("tagsKanban.toasts.tagInUse"));
            return;
          }
        } catch (e) {
          console.error("Error checking tag usage by ID", e);
        }
      } else {
        // Legacy string validation (checking by name)
        // ... (Keep existing logic if needed or skip)
      }

      // Calculate new lists
      let newLaneTagIds = [];

      // Relational Handling
      if (lane.kanbanLaneTags && lane.kanbanLaneTags.length > 0) {
        const currentTags = lane.kanbanLaneTags.map(klt => klt.tag);
        const filtered = currentTags.filter(t => t.id !== tagId); // Filter by ID
        newLaneTagIds = filtered.map(t => t.id);
      }

      const payload = { ...lane, laneTagIds: newLaneTagIds };

      await api.put(`/tags/${lane.id}`, payload);
      toast.success(i18n.t("tagsKanban.toasts.deleted"));

    } catch (err) {
      toastError(err);
    }
  };

  const handleOpenEditLaneTag = (tag, laneTagStr) => {
    setSelectedLaneTag({ tag, value: laneTagStr });
    setEditLaneTagModalOpen(true);
  };

  const handleSaveLaneTag = async (oldValue, newValue) => {
    const laneTag = selectedLaneTag.value; // The tag object
    try {
      if (laneTag && laneTag.id) {
        // Rename the global tag entity
        await api.put(`/tags/${laneTag.id}`, { name: newValue });
        toast.success(i18n.t("tagsKanban.toasts.updated"));
      }
    } catch (err) {
      toastError(err);
    }
  };

  const getOrderedTags = (boardId) => {
    const boardTags = tags.filter((t) => t.kanbanBoardId === boardId);
    const savedOrder = laneOrders[boardId];

    if (savedOrder && savedOrder.length > 0) {
      const ordered = [];
      const tagMap = new Map(boardTags.map(t => [String(t.id), t]));

      // 1. Agregar según orden guardado
      savedOrder.forEach(id => {
        if (tagMap.has(String(id))) {
          ordered.push(tagMap.get(String(id)));
          tagMap.delete(String(id));
        }
      });

      // 2. Agregar tags nuevos al final (por ID)
      const remaining = Array.from(tagMap.values()).sort((a, b) => a.id - b.id);
      return [...ordered, ...remaining];
    }

    // Default: Sort by ID as requested originally
    return boardTags.sort((a, b) => a.id - b.id);
  };

  const { setKanbanLaneOrder } = require("../../services/companyKanbanService");

  const handleMoveLane = async (boardId, tagId, direction) => {
    const boardTags = getOrderedTags(boardId);
    const index = boardTags.findIndex(t => t.id === tagId);
    if (index === -1) return;

    const newTags = [...boardTags];
    const targetIndex = direction === 'up' ? index - 1 : index + 1;

    if (targetIndex < 0 || targetIndex >= newTags.length) return;

    // Swap
    [newTags[index], newTags[targetIndex]] = [newTags[targetIndex], newTags[index]];

    const newOrder = newTags.map(t => String(t.id));

    // Actualización local rápida
    setLaneOrders(prev => ({ ...prev, [boardId]: newOrder }));

    try {
      await setKanbanLaneOrder(newOrder, boardId);
      toast.success(i18n.t("kanban.messages.successReorder"));
    } catch (err) {
      toastError(err);
    }
  };

  return (
    <MainContainer>
      <ConfirmationModal
        title={deletingTag && `${i18n.t("tagsKanban.confirmationModal.deleteTitle")}`}
        open={confirmModalOpen}
        onClose={setConfirmModalOpen}
        onConfirm={() => handleDeleteTag(deletingTag.id)}
      >
        {i18n.t("tagsKanban.confirmationModal.deleteMessage")}
      </ConfirmationModal>

      {tagModalOpen && (
        <TagModal
          open={tagModalOpen}
          onClose={handleCloseTagModal}
          aria-labelledby="form-dialog-title"
          tagId={selectedTag && selectedTag.id}
          kanban={1}
        />
      )}

      <EditLaneTagModal
        open={editLaneTagModalOpen}
        onClose={() => setEditLaneTagModalOpen(false)}
        laneTag={selectedLaneTag.value}
        onSave={handleSaveLaneTag}
      />

      
      <BrandModal 
        open={brandModalOpen}
        onClose={() => setBrandModalOpen(false)}
        brandId={selectedBrandId}
        onSave={() => fetchBrands()}
      />
      <KanbanBoardModal 
        open={boardModalOpen}
        onClose={() => setBoardModalOpen(false)}
        boardId={selectedBoardId}
        brandId={activeBrandId}
        onSave={() => {
          const fetchBoards = async () => {
            if (!activeBrandId) return;
            const { data } = await api.get(`/kanban-boards?brandId=${activeBrandId}`);
            setBoards(data);
          };
          fetchBoards();
        }} 
      />

      <MainHeader>
        <Title>Embudos (Tableros)</Title>
        <MainHeaderButtonsWrapper>
          <FormControl variant="outlined" margin="dense" style={{ minWidth: 200, marginRight: 8 }}>
            <InputLabel>Marca</InputLabel>
            <Select
              value={activeBrandId}
              onChange={(e) => setActiveBrandId(e.target.value)}
              label="Marca"
            >
              {brands.map(b => (
                <MenuItem key={b.id} value={b.id}>{b.name}</MenuItem>
              ))}
            </Select>
          </FormControl>
          <Button variant="outlined" color="primary" onClick={() => { setSelectedBrandId(null); setBrandModalOpen(true); }}>
            + Marca
          </Button>
          {activeBrandId && (
            <>
              <Button variant="outlined" color="primary" onClick={() => { setSelectedBrandId(activeBrandId); setBrandModalOpen(true); }}>
                Editar Marca
              </Button>
              <Button variant="contained" color="secondary" onClick={() => { setSelectedBoardId(null); setBoardModalOpen(true); }}>
                + Embudo
              </Button>
            </>
          )}
          <TextField
            placeholder={i18n.t("contacts.searchPlaceholder")}
            type="search"
            value={searchParam}
            onChange={handleSearch}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon style={{ color: "gray" }} />
                </InputAdornment>
              ),
            }}
          />
          <Button variant="contained" color="primary" onClick={handleOpenTagModal}>
            + Etapa
          </Button>
        </MainHeaderButtonsWrapper>
      </MainHeader>

      <Paper className={classes.mainPaper} variant="outlined">
        {boards.map((board) => (
          <Accordion
            key={board.id}
            defaultExpanded={true}
            className={classes.accordion}
          >
            
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls={`panel-${board.id}-content`}
              id={`panel-${board.id}-header`}
              className={classes.stickySummary}
            >
              <Box display="flex" justifyContent="space-between" alignItems="center" width="100%">
                <Typography className={classes.heading}>{board.name}</Typography>
                <Box>
                  <IconButton size="small" onClick={(e) => { e.stopPropagation(); setSelectedBoardId(board.id); setBoardModalOpen(true); }}>
                    <EditIcon />
                  </IconButton>
                </Box>
              </Box>
            </AccordionSummary>

            <AccordionDetails className={classes.accordionDetails}>
              <Table size="small" stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell width="5%" className={classes.stickyTableHeader} />
                    <TableCell align="center" style={{ width: '35%' }} className={classes.stickyTableHeader}>{i18n.t("tagsKanban.table.name")}</TableCell>
                    <TableCell align="center" style={{ width: '30%' }} className={classes.stickyTableHeader}>{i18n.t("tagsKanban.table.tickets")}</TableCell>
                    <TableCell align="center" style={{ width: '30%' }} className={classes.stickyTableHeader}>{i18n.t("tagsKanban.table.actions")}</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {getOrderedTags(board.id)
                    .map((tag, index, array) => (
                      <Row
                        key={tag.id}
                        tag={tag}
                        classes={classes}
                        isFirst={index === 0}
                        isLast={index === array.length - 1}
                        onMoveUp={() => handleMoveLane(board.id, tag.id, 'up')}
                        onMoveDown={() => handleMoveLane(board.id, tag.id, 'down')}
                        handleEditTag={handleEditTag}
                        setConfirmModalOpen={setConfirmModalOpen}
                        setDeletingTag={setDeletingTag}
                        handleEditLaneTag={handleOpenEditLaneTag}
                        handleDeleteLaneTag={handleDeleteLaneTag}
                      />
                    ))}
                  {getOrderedTags(board.id).length === 0 && (
                    <TableRow>
                      <TableCell colSpan={4} align="center">
                        {i18n.t("tagsKanban.table.noTags")}
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </AccordionDetails>
          </Accordion>
        ))}

        {/* Render tags without board */}
        {tags.filter(t => !t.kanbanBoardId).length > 0 && (
          <Accordion>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel-noboard-content"
              id="panel-noboard-header"
              className={classes.stickySummary}
            >
              <Typography className={classes.heading} color="error">{i18n.t("tagsKanban.noBoard") || "No Board"}</Typography>
            </AccordionSummary>
            <AccordionDetails className={classes.accordionDetails}>
              <Table size="small" stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell width="5%" className={classes.stickyTableHeader} />
                    <TableCell align="center" style={{ width: '35%' }} className={classes.stickyTableHeader}>{i18n.t("tagsKanban.table.name")}</TableCell>
                    <TableCell align="center" style={{ width: '30%' }} className={classes.stickyTableHeader}>{i18n.t("tagsKanban.table.tickets")}</TableCell>
                    <TableCell align="center" style={{ width: '30%' }} className={classes.stickyTableHeader}>{i18n.t("tagsKanban.table.actions")}</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {tags.filter(t => !t.kanbanBoardId).map((tag) => (
                    <Row
                      key={tag.id}
                      tag={tag}
                      classes={classes}
                      handleEditTag={handleEditTag}
                      setConfirmModalOpen={setConfirmModalOpen}
                      setDeletingTag={setDeletingTag}
                      handleEditLaneTag={handleOpenEditLaneTag}
                      handleDeleteLaneTag={handleDeleteLaneTag}
                    />
                  ))}
                </TableBody>
              </Table>
            </AccordionDetails>
          </Accordion>
        )}

        {loading && (
          <Table size="small">
            <TableBody>
              <TableRowSkeleton columns={3} />
            </TableBody>
          </Table>
        )}
      </Paper>
    </MainContainer>
  );
};

export default Tags;
